// extracted by mini-css-extract-plugin
export default {"planMenuItem":"PlanMenuItem_planMenuItem__1-W1b"};